import { Route, Routes } from '@angular/router';
import { BrightnavShellComponent } from '../layout/shell/brightnav-shell.component';
import { authGroupGuard, authGuard } from '@brightside/core/auth';
import { AmplitudeService } from '@brighthub/logging';
import { BrightNavAmplitudeService } from '@brighthub/brightnav-logging';
import { BrightNavOmniSearchRegistry } from '@brighthub/brightnav-registry';
import { ConversationLayoutComponent } from '../layout/conversation-layout/conversation-layout.component';
import { MyClientsRouteComponent } from '../layout/my-clients-route/my-clients-route.component';
import { EmployeeLayoutComponent } from '../layout/employee-layout/employee-layout.component';
import { BRIGHTNAV_ADMIN_DEVELOPER_OKTA_GROUP, BRIGHTNAV_ADMIN_OKTA_GROUP } from '@brighthub/admin-contract';

/** Shared children under the canonical `/brightnav` shell. */
const brightnavChildren: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'myclients',
  },
  {
    path: 'myclients',
    component: MyClientsRouteComponent,
  },
  {
    path: 'conversation',
    component: ConversationLayoutComponent,
    canMatch: [authGroupGuard([BRIGHTNAV_ADMIN_OKTA_GROUP])],
  },
  {
    path: 'conversation/:conversationId',
    component: ConversationLayoutComponent,
    canMatch: [authGroupGuard([BRIGHTNAV_ADMIN_OKTA_GROUP])],
  },
  {
    path: 'employee',
    component: EmployeeLayoutComponent,
    canMatch: [authGroupGuard([BRIGHTNAV_ADMIN_OKTA_GROUP])],
  },
  {
    path: 'employee/:oktaId',
    component: EmployeeLayoutComponent,
    canMatch: [authGroupGuard([BRIGHTNAV_ADMIN_OKTA_GROUP])],
  },
  {
    path: 'admin',
    canMatch: [authGroupGuard([BRIGHTNAV_ADMIN_DEVELOPER_OKTA_GROUP])],
    loadChildren: () =>
      import('@brighthub/brightnav-admin').then((m) => m.brightnavAdminFeatureRoutes),
  },
];

function brightnavShellRoute(path: string): Route {
  return {
    path,
    component: BrightnavShellComponent,
    canActivate: [authGuard],
    canActivateChild: [authGuard],
    providers: [
      { provide: AmplitudeService, useClass: BrightNavAmplitudeService },
      BrightNavOmniSearchRegistry,
    ],
    children: brightnavChildren,
  };
}

/** Conversation / employee tools use the broader admin group; the Administration SPA uses {@link BRIGHTNAV_ADMIN_DEVELOPER_OKTA_GROUP}. */
export const BrightnavRoutes: Routes = [
  brightnavShellRoute('brightnav'),
  /**
   * @deprecated Legacy URL prefix — redirect bookmarks/deep links onto canonical `/brightnav/**`.
   * `pathMatch: 'prefix'` preserves the remainder (`/brightai/myclients` → `/brightnav/myclients`).
   */
  {
    path: 'brightai',
    redirectTo: 'brightnav',
    pathMatch: 'prefix',
  },
];
